export function headerSettings() {
  const headerElement = document.querySelector('.header');
  const headerBurgerElement = document.querySelector('.header__burger');
  const headerMenuElement = document.querySelector('.header__bar');
  const menuItems = document.querySelectorAll('.header__menu-item');
  const bodyElement = document.body;
  const CLASS_OPEN = 'open-menu';
  const OVERFLOW_CLASS = 'overflow';

  if (!headerElement || !headerBurgerElement || !headerMenuElement) {
    return;
  }

  function openMenu() {
    bodyElement.classList.add(OVERFLOW_CLASS);
    headerBurgerElement.classList.add(CLASS_OPEN);
    headerMenuElement.classList.add(CLASS_OPEN);
  }

  function closeMenu() {
    bodyElement.classList.remove(OVERFLOW_CLASS);
    headerBurgerElement.classList.remove(CLASS_OPEN);
    headerMenuElement.classList.remove(CLASS_OPEN);
  }

  headerBurgerElement.addEventListener('click', () => {
    if (headerBurgerElement.classList.contains(CLASS_OPEN)) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  if (menuItems.length) {
    menuItems.forEach(el => {
      el.addEventListener('click', closeMenu);
    })
  }
}


// WEBPACK FOOTER //
// app/scripts/components/header.js